<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <slot></slot>
  </transition>
</template>

<script>
export default {
  methods: {
    beforeEnter(el) {
      el.classList.add('collapse-transition')
      el.dataset.oldPaddingTop = el.style.paddingTop
      el.dataset.oldPaddingBottom = el.style.paddingBottom
      el.dataset.oldOverflow = el.style.overflow
      el.style.overflow = 'hidden'
      el.style.height = '0'
      el.style.paddingTop = 0
      el.style.paddingBottom = 0
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
      el.style.paddingTop = '20px'
      el.style.paddingBottom = '20px'
    },

    afterEnter(el) {
      el.classList.remove('collapse-transition')
      el.style.height = ''
      el.style.overflow = el.dataset.oldOverflow
    },

    beforeLeave(el) {
      el.dataset.oldPaddingTop = el.style.paddingTop
      el.dataset.oldPaddingBottom = el.style.paddingBottom
      el.dataset.oldOverflow = el.style.overflow
      el.style.height = el.scrollHeight + 'px'
      el.style.overflow = 'hidden'
    },

    leave(el) {
      this.$nextTick(() => {
        el.classList.add('collapse-transition')
        el.style.height = 0
        el.style.paddingTop = 0
        el.style.paddingBottom = 0
      })
    },

    afterLeave(el) {
      this.$nextTick(() => {
        el.classList.remove('collapse-transition')
        el.style.height = ''
        el.style.overflow = el.dataset.oldOverflow
        el.style.paddingTop = '20px'
        el.style.paddingBottom = '20px'
      })
    }
  }
}
</script>

<style lang="less">
.collapse-transition {
  transition: all 0.15s ease-in-out;
}
</style>
